document.addEventListener("DOMContentLoaded", function () {
    // Multiple instances of this widget can exist on one page (the homepage
    // block and the floating chat panel both render a .typewriter-slider),
    // so each needs its own independent animation loop/state.
    document.querySelectorAll(".typewriter-slider").forEach(function (el) {
        const titles = JSON.parse(el.getAttribute("data-titles"));
        let i = 0, text = "", isDeleting = false;

        function type() {
            const fullText = titles[i];

            // variable speed: random between 50–120ms per character
            let typingSpeed = isDeleting ? 40 : 80 + Math.random() * 40;

            // add a natural pause if we just typed punctuation
            if (!isDeleting && text.endsWith("?")) typingSpeed = 500;
            if (!isDeleting && text.endsWith(".")) typingSpeed = 400;

            if (!isDeleting && text !== fullText) {
                text = fullText.substring(0, text.length + 1);
            } else if (isDeleting && text !== "") {
                text = fullText.substring(0, text.length - 1);
            } else if (!isDeleting && text === fullText) {
                // pause before starting to delete
                typingSpeed = 5000;
                isDeleting = true;
            } else if (isDeleting && text === "") {
                // move to next title
                isDeleting = false;
                i = (i + 1) % titles.length;
            }

            el.innerHTML = text + "<span class='cursor'>|</span>";
            setTimeout(type, typingSpeed);
        }

        type();
    });
});

document.querySelectorAll('.ai-bot-button').forEach(function (aiChatTrigger) {
    aiChatTrigger.addEventListener('click', function() {
        // Scope to this trigger's own chat-wrapper so it doesn't reach across
        // the page and grab a different instance of the widget (e.g. the
        // floating chat panel's .ai-bot).
        const targetElement = aiChatTrigger.closest('.chat-wrapper')?.querySelector('.ai-bot');
        if (!targetElement) return;
        aiChatTrigger.classList.add('triggered');
        targetElement.classList.add('triggered');
    });
});